import AsyncStorage from '@react-native-async-storage/async-storage';
import React, { useState } from 'react';
import { ActivityIndicator, Text, TouchableOpacity, View } from 'react-native';
import { FormattedMessage, useIntl } from 'react-intl';

import { LinearGradient } from 'expo-linear-gradient';
import HeaderDefault from '../../components/HeaderDefault';
import api from '../../services/api';
import { toast } from '../../utils/toast';

import styles from './styles';

const DeleteCard = ({ route, navigation }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { item } = route.params;

    async function deleteCard() {
        setIsLoading(true);
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        api.delete(`/cards/${item.id}`, { headers: { 'Authorization': `Bearer ${token}` } })
            .then(() => {
                navigation.navigate('MyCards');
                setIsLoading(false);
            })
            .catch((error) => {
                const intl = useIntl();
                toast(intl.formatMessage({id:'deleteCard.erroCarregaDados'}), "#DA1414");
                setIsLoading(false);
            })
    }


    return (
        <>
            <HeaderDefault title={<FormattedMessage id='deleteCard.headerEscluiCartao'/>} />

            <Text style={styles.textInfo}>
            <FormattedMessage id='deleteCard.msgDesejaExcluir'/>
            </Text>

            <View style={styles.contentBtn}>
                <TouchableOpacity disabled={isLoading ? true : false} onPress={deleteCard}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#8F0101", "#8F0101"]}
                        style={styles.btn}
                    >
                        {isLoading ? (
                            <ActivityIndicator color="#2797A2" size="small" />
                        ) : (
                            <Text style={styles.textBtn}><FormattedMessage id='deleteCard.excluir'/></Text>
                        )}
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    )
}

export default DeleteCard;